import AbstractRequestTask from '../AbstractRequestTask';
import getAppConfig from '../../../config/appConfig';
import storage from '../../../components/DeviceStorage/DeviceStorage';
import settings from '../../../devices/all/settings';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class FollowRadioTask extends AbstractRequestTask {
	constructor(service = '', user, params, headers) {
		super();
		this._config = getAppConfig();
		this._service = service;
		this._user = user;
		const region = storage.getItem('region');
		const { tenant_code } = settings;

		if (headers && headers.cm_access_token) {
			delete headers.cm_access_token;
		}

		this._params = {
			...params,
			authpn: this._config.authpn,
			authpt: this._config.authpt,
			device_type: this._config.device_type,
			device_model: this._config.device_model,
			device_manufacturer: this._config.device_manufacturer,
			device_category: this._config.device_category,
			device_id: this._config.device_id,
			device_name: this._config.device_name,
			device_so: this._config.device_so,
			format: this._config.format,
			region: region,
			tenant_code: tenant_code,
			user_id: user.id,
			cm_access_token: user.cm_access_token
		};
		this._headers = headers || {};
	}

	getMethod() {
		return 'GET';
	}

	getEncType() {
		return 'application/x-www-form-urlencoded';
	}

	isValid(data) {
		return !(data.errors && !data.ribbons && !data.albumDetail && !data.playlistDetail);
	}

	getUrl() {
		return `${this._config.end_point_music}/${this._service}`;
	}

	getParams() {
		const params = super.getParams();
		params.version = '1.0.0';

		return { ...this._params, ...params };
	}

	getHeaders() {
		return {
			...this._headers
		};
	}

	success(data, b) {
		this.resolve(data);
	}

	getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default FollowRadioTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/FollowRadioTask.js